import { Stack } from 'components/Stack'
import { ComponentProps } from 'react'
import { CollapsibleMenu } from '../CollapsibleMenu'
import { DesktopMenuRoot } from './DesktopMenu.styles'
import useTranslation from 'next-translate/useTranslation'

type DesktopMenuOwnProps = ComponentProps<typeof DesktopMenuRoot>
export type DesktopMenuProps = DesktopMenuOwnProps & {
  menusections: MenuSection[]
  activesection: string
}

export type MenuSection = { title: string; items?: MenuItem[]; cta?: MenuItem }
export type MenuItem = { label: string; url: string }

export const DesktopMenu = (props: DesktopMenuProps) => {
  const { menusections, activesection } = props
  const { t } = useTranslation()

  return (
    <DesktopMenuRoot {...props}>
      <Stack gap="2" direction="column">
        {menusections.map(({ title, ...rest }) => (
          <CollapsibleMenu
            key={title}
            label={title}
            title={title}
            activeSection={activesection}
            {...rest}
          />
        ))}
      </Stack>
    </DesktopMenuRoot>
  )
}

DesktopMenu.displayName = 'DesktopMenu'
